import { Nullable } from 'common/models/optional';
import React from 'react';
import Select, { components } from 'react-select';
import { TokenIcon, TokenName } from '../TokenIcons/TokenIcon';
import { StyledMintOption, StyledSelectToken } from './selectToken.style';
import { MintableToken } from 'constants/contracts';

type Props = {
  name: string;
  values: MintableToken[];
  isLoading: boolean;
  isCollateral?: boolean;
  value: MintableToken;
  onChange: (value: MintableToken) => void;
  id?: string;
};

// References: https://medium.com/codingtown/react-select-852e90d549df
// https://github.com/JedWatson/react-select/issues/2553
// https://github.com/JedWatson/react-select
// https://react-select.com/components
const SelectToken: React.FC<Props> = (props) => {
  type RenderStyledMintOptionArgs = {
    data: MintableToken;
  };
  const RenderStyledMintOption = (args: RenderStyledMintOptionArgs) => {
    const name = props.isCollateral
      ? (args.data.collateralToken?.name as string)
      : (args.data.token.name as string);
    const symbol = props.isCollateral
      ? (args.data.collateralToken?.symbol as string)
      : (args.data.token.symbol as string);
    return (
      <StyledMintOption>
        <TokenIcon name={symbol as TokenName} />
        <span className="primary-text-color">{name}</span>
      </StyledMintOption>
    );
  };

  const TokenOption = (innerProps) => {
    return (
      <components.Option {...innerProps}>
        <RenderStyledMintOption {...innerProps} />
      </components.Option>
    );
  };

  const TokenSingleValue = (innerProps) => {
    return (
      <components.SingleValue {...innerProps}>
        <RenderStyledMintOption {...innerProps} />
      </components.SingleValue>
    );
  };

  const onChange = (c: Nullable<MintableToken>) => {
    props.onChange(c as MintableToken);
  };

  const getName = (c: MintableToken) => {
    return props.isCollateral
      ? (c.collateralToken?.name as string)
      : (c.token.name as string);
  };

  const getSymbol = (c: MintableToken) => {
    return props.isCollateral
      ? (c.collateralToken?.symbol as string)
      : (c.token.symbol as string);
  };

  return (
    <StyledSelectToken className="styled-select-token" id={props.id}>
      <Select<MintableToken>
        className="basic-single"
        classNamePrefix="select"
        defaultValue={props.value}
        value={props.value}
        getOptionLabel={getName}
        getOptionValue={getSymbol}
        isDisabled={false}
        isLoading={props.isLoading}
        name={props.name}
        options={props.values}
        components={{
          Option: TokenOption,
          SingleValue: TokenSingleValue,
        }}
        onChange={onChange}
      />
    </StyledSelectToken>
  );
};

export default SelectToken;
